export default __webpack_public_path__ + "static/media/Path -21.d8444790.png";